import useMutationApi from 'src/api/useMutationApi';

interface Body {
  isaId: string | null;
}

const useUpdateCustomerIsaId = (customerId: string, onSuccess?: () => void) => {
  return useMutationApi<Body, void>({
    endpoint: `accounts-receivable/customers/${customerId}/isa-id`,
    method: 'POST',
    options: {
      onSuccess,
    },
    showSuccessToast: true,
  });
};

export default useUpdateCustomerIsaId;
